import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import Timesheets from '../../../Components/pages/timesheets/Timesheets';
import { getConstants } from '../../../actions/constFromApi';
import classes from './TimesheetsPage.module.scss';
import { getTandECountsContractor, getTandEPendingCounts } from '../../../actions/timesheet';

export default function TimesheetsPage() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const constants = useSelector((state) => state.constFromApi);
  const isApprover = useSelector((state) => state.accessToParts.tAndEApprover);
  const tsCounts = isApprover
    ? {
        /* TODO need BE to rework response for GET v1/get-tne-count the same as for GET v1/get-tne-count-contractor */
      }
    : useSelector((state) => state.timesheet.contractortandecounts?.Timesheet);
  const [key, setKey] = useState(1);

  useEffect(() => {
    if (searchParams.has('status') && !searchParams.has('page')) {
      setKey((prev) => prev + 1);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!constants.clients?.length || !constants.worktypes?.length) dispatch(getConstants(true));
    if (!tsCounts) dispatch(isApprover ? getTandEPendingCounts() : getTandECountsContractor());
  }, [constants.clients?.length, constants.worktypes?.length]);

  return <section className={`${classes.pageContainer}`}>{tsCounts && <Timesheets key={key} />}</section>;
}
